



























import { Component, Prop, Vue } from "vue-property-decorator";

interface GlobalNote {
    title: string;
    body: string;
}

@Component
export default class GlobalExplainer extends Vue {
    /** Full catalog payload from /roadclosureanalytics/metric_catalog. */
    @Prop({ default: null }) catalog!: any;

    /** Notes from catalog.global_notes — mirrors the prototype's _render_global_explainer. */
    get notes(): GlobalNote[] {
        const raw = this.catalog?.global_notes;
        return Array.isArray(raw) ? raw : [];
    }
}
